// typescript
import * as React from 'react';

type BrittishFlagProps = {
  size?: number | string;
  title?: string;
  className?: string;
  style?: React.CSSProperties;
};

function BrittishFlag({
  size = 32,
  title = 'British flag',
  className,
  style,
}: BrittishFlagProps) {
  const id = React.useId();
  const clipId = `uk-clip-${id}`;
  const s = typeof size === 'number' ? `${size}px` : size;

  return (
    <span
      role='img'
      aria-label={title}
      title={title}
      className={className}
      style={{
        display: 'inline-block',
        width: s,
        height: s,
        borderRadius: '50%',
        overflow: 'hidden',
        lineHeight: 0,
        ...style,
      }}
    >
      <svg
        width='100%'
        height='100%'
        viewBox='0 0 32 32'
        preserveAspectRatio='xMidYMid meet'
        xmlns='http://www.w3.org/2000/svg'
        style={{ display: 'block' }}
      >
        <defs>
          <clipPath id={clipId}>
            <circle cx='16' cy='16' r='16' />
          </clipPath>
        </defs>

        {/* outer circle background */}
        <circle cx='16' cy='16' r='16' fill='#012169' />

        {/* flag artwork clipped to circle */}
        <g clipPath={`url(#${clipId})`}>
          <rect x='0' y='0' width='32' height='32' fill='#012169' />
          <path d='M0 0 L32 32' stroke='#fff' strokeWidth='6' strokeLinecap='butt' />
          <path d='M32 0 L0 32' stroke='#fff' strokeWidth='6' strokeLinecap='butt' />
          <path d='M0 0 L32 32' stroke='#C8102E' strokeWidth='3.2' strokeLinecap='butt' />
          <path d='M32 0 L0 32' stroke='#C8102E' strokeWidth='3.2' strokeLinecap='butt' />
          <rect x='13' y='0' width='6' height='32' fill='#fff' />
          <rect x='0' y='13' width='32' height='6' fill='#fff' />
          <rect x='14.5' y='0' width='3' height='32' fill='#C8102E' />
          <rect x='0' y='14.5' width='32' height='3' fill='#C8102E' />
        </g>
      </svg>
    </span>
  );
}

export default BrittishFlag;
